/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { formatCurrency } from 'cio/helpers/format-currency';
import PlanModel from 'cio/models/plan';
import BillingService from 'cio/services/billing';
import { Plan, Plans } from 'cio/utils/billing/plans';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import AnalyticsService from 'cio/services/analytics';
import AccountService from 'cio/services/account';
import { tracked } from '@glimmer/tracking';

interface PlanNameHeaderArgs {
  planTemplate: Plan;
  showCheckout: boolean;
  cdpPremiumPrice: number;
  hasPinnedPlan: boolean;
  pinnedPlan: PlanModel;
  isPrimary: boolean;
  isPremiumTrial: boolean;
}

export default class PlanNameHeader extends Component<PlanNameHeaderArgs> {
  @service billing!: BillingService;
  @service analytics!: AnalyticsService;
  @service account!: AccountService;

  @tracked showPinnedPlanModal = false;

  get formattedPrice() {
    return formatCurrency([this.args.planTemplate.basePrice], { precision: 0 });
  }

  get planPricePlusCdpPremiumPrice() {
    let price = this.args.pinnedPlan.price + this.args.cdpPremiumPrice;
    return formatCurrency([price], { precision: 0 });
  }

  get showPrice() {
    return (
      this.args.planTemplate.planType === Plans.Essentials.planType ||
      this.args.planTemplate.planType === Plans.Premium.planType ||
      this.args.planTemplate.planType === Plans.CdpStarter.planType
    );
  }

  get isCdpPlan() {
    return (
      this.args.planTemplate.planType === Plans.CdpStarter.planType ||
      this.args.planTemplate.planType === Plans.CdpPremium.planType
    );
  }

  get purpleOrPlumScribble() {
    let { isPrimary, isPremiumTrial, planTemplate } = this.args;
    if (isPrimary === true || (isPremiumTrial !== true && planTemplate.planType === Plans.Essentials.planType)) {
      return 'purple-scribble';
    }
    return 'plum-scribble';
  }

  get pinnedPlanUsageInDollars() {
    return Number(this.args.pinnedPlan.meteredCustomerRate) * 1000;
  }

  get pinnedPlanObjectsUsageInDollars() {
    return Number(this.args.pinnedPlan.meteredObjectRate) * 1000;
  }

  @action
  async openModal() {
    this.showPinnedPlanModal = true;
    let account = this.account.current;
    let { currentUser } = account;
    let data = {
      account_id: account.id,
      requester: currentUser.fullName,
      requester_email: currentUser.email,
      requester_user_id: currentUser.id,
    };
    this.analytics.track('plan_billing', 'included_in_plan_viewed', { data });
  }
}
